import { Link } from "react-router-dom";
import { CheckCircle2, Mail, ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { usePageMeta } from "@/utils/pageMeta";

const PaymentSuccess = () => {
  usePageMeta(
    "Paiement confirmé — ActiPilote",
    "Votre abonnement ActiPilote a bien été enregistré. Un e-mail d'activation vient de vous être envoyé."
  );

  return (
    <section data-testid="payment-success-page" className="relative overflow-hidden pt-32 pb-20 sm:pt-40 sm:pb-28">
      <div className="bg-grid-faint pointer-events-none absolute inset-0" aria-hidden="true" />
      <div className="pointer-events-none absolute -top-24 left-1/2 h-72 w-[560px] -translate-x-1/2 rounded-full bg-turquoise/10 blur-[110px]" aria-hidden="true" />

      <div className="relative mx-auto max-w-xl px-4 sm:px-6">
        <Reveal>
          <div className="rounded-3xl border border-slate-200 bg-white p-8 text-center shadow-lift sm:p-12">
            <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-turquoise/10 text-turquoise">
              <CheckCircle2 className="h-9 w-9" />
            </span>
            <h1 className="mt-6 text-3xl font-extrabold tracking-tight text-navy sm:text-4xl">Paiement confirmé</h1>
            <p className="mt-3 text-base font-semibold text-navy/75 sm:text-lg">
              Votre abonnement ActiPilote a bien été enregistré.
            </p>
            <p className="mt-4 text-sm leading-relaxed text-navy/60 sm:text-base">
              Un e-mail d'activation vient de vous être envoyé. Cliquez sur le lien contenu dans cet e-mail
              pour créer votre accès et terminer la configuration de votre compte.
            </p>
            <p className="mt-4 rounded-xl bg-mist px-4 py-3 text-xs leading-relaxed text-navy/55">
              Vous ne trouvez pas l'e-mail ? Vérifiez vos courriers indésirables.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
              <a href="mailto:" data-testid="open-mail-button" className="group inline-flex items-center justify-center gap-2 rounded-full bg-brand px-7 py-3.5 text-sm font-bold text-white shadow-glow transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-700">
                <Mail className="h-4 w-4" /> Ouvrir ma boîte mail
              </a>
              <Link to="/" data-testid="back-home-button" className="inline-flex items-center justify-center gap-2 rounded-full border border-slate-200 px-7 py-3.5 text-sm font-bold text-navy transition-colors hover:border-brand/40 hover:text-brand">
                <ArrowLeft className="h-4 w-4" /> Retour à l'accueil
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default PaymentSuccess;
